import Vue from 'vue'
import App from './views/Admin.vue'
import router from './router'
import http from '@/http'
import EventBus from 'vue-bus'

import 'iview/dist/styles/iview.css';

import { Message } from 'iview';

Vue.prototype.$Message = Message;

Vue.prototype.$Message.config({
	top: 200,
	duration: 3
})

Vue.config.productionTip = false

Vue.use(http)
Vue.use(EventBus)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')